module.exports = __webpack_public_path__ + "static/media/merchant_icon_gradient.57179b76.png";